import { createContext, useContext, useState } from 'react';

const ConverterContext = createContext();

export function OmniboxCsvConverterProvider({ children }) {
  const [ unitSystem, setUnitSystem ] = useState('metric');
  const [ selectedFile, setSelectedFile ] = useState(null);
  const [ prodLines, setProdLines ] = useState([]);
  const [ delimString, setDelimString ] = useState('');

  const value = {
    unitSystem, setUnitSystem,
    selectedFile, setSelectedFile,
    prodLines, setProdLines,
    delimString, setDelimString
  };

  return (
    <ConverterContext.Provider value={value}>
      {children}
    </ConverterContext.Provider>
  )
}

export function useAppState() {
  return useContext(ConverterContext);
}